import { render, staticRenderFns } from "./PromoSection.vue?vue&type=template&id=7aa0c881&scoped=true&"
import script from "./PromoSection.vue?vue&type=script&lang=js&"
export * from "./PromoSection.vue?vue&type=script&lang=js&"
import style0 from "./PromoSection.vue?vue&type=style&index=0&id=7aa0c881&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa0c881",
  null
  
)

export default component.exports